var render = function () {
  var _vm$festa$section2$tx, _vm$festa$section2$tx2, _vm$festa, _vm$festa$section, _vm$festa2, _vm$festa2$section;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', {
    scopedSlots: _vm._u([{
      key: "subHead",
      fn: function fn() {
        return [_c('sub-visual', {
          attrs: {
            "title": "유통데이터 활용 경진대회 소개",
            "src": "/images/sub/sub-visual-circulation.jpg"
          }
        })];
      },
      proxy: true
    }])
  }, [_vm.festa ? [_c('page-section', {
    staticClass: "page-section--first",
    attrs: {
      "title": "행사소개"
    }
  }, [_c('div', {
    staticClass: "tit-wrap pb-0"
  }, [_c('h3', {
    staticClass: "tit tit--xl",
    attrs: {
      "data-aos": "fade-right",
      "data-aos-delay": "100"
    }
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s((_vm$festa$section2$tx = _vm.festa.section2.txt[0]) === null || _vm$festa$section2$tx === void 0 ? void 0 : _vm$festa$section2$tx.replace(/\n/g, '<br/>'))
    }
  })]), _c('div', {
    staticClass: "txt txt--lg txt--dark",
    attrs: {
      "data-aos": "fade-right",
      "data-aos-delay": "200"
    }
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s((_vm$festa$section2$tx2 = _vm.festa.section2.txt[1]) === null || _vm$festa$section2$tx2 === void 0 ? void 0 : _vm$festa$section2$tx2.replace(/\n/g, '<br/>'))
    }
  })])]), _c('div', {
    staticClass: "page-section__bg",
    staticStyle: {
      "background-image": "url(/images/common/grey-bg.png)"
    }
  })]), _c('page-section', {
    staticClass: "pb-0",
    attrs: {
      "title": "데이터를 활용한 새로운 전략 제시",
      "text": (_vm$festa = _vm.festa) === null || _vm$festa === void 0 ? void 0 : (_vm$festa$section = _vm$festa.section1) === null || _vm$festa$section === void 0 ? void 0 : _vm$festa$section.txt
    }
  }, [_c('v-img', {
    staticClass: "d-none d-md-block",
    attrs: {
      "src": "/images/sub/circulation/circulation-img.jpg",
      "aspect-ratio": 1200 / 632,
      "max-width": "1200",
      "contain": "",
      "data-aos": "fade-up",
      "data-aos-delay": "100"
    }
  }), _c('v-img', {
    staticClass: "d-md-none mx-auto",
    attrs: {
      "src": "/images/sub/circulation/circulation-img-mo.jpg",
      "max-width": "672",
      "contain": "",
      "data-aos": "fade-up",
      "data-aos-delay": "100"
    }
  })], 1), _c('page-section', {
    staticClass: "pb-0",
    attrs: {
      "title": "행사개요"
    }
  }, [_c('table-primary', _vm._l(_vm.festa.section3.table.list, function (item, index) {
    return _c('table-primary-row', {
      key: index,
      scopedSlots: _vm._u([{
        key: "title",
        fn: function fn() {
          return [_c('span', {
            domProps: {
              "innerHTML": _vm._s(item.title.replace(/\n/g, '<br />'))
            }
          })];
        },
        proxy: true
      }, {
        key: "text",
        fn: function fn() {
          return [_c('p', {
            domProps: {
              "innerHTML": _vm._s(item.input.replace(/\n/g, '<br />'))
            }
          })];
        },
        proxy: true
      }], null, true)
    });
  }), 1)], 1), _c('page-section', {
    staticClass: "pb-0",
    attrs: {
      "title": "프로세스"
    }
  }, [_c('v-img', {
    staticClass: "d-none d-md-block",
    attrs: {
      "src": "/images/sub/circulation/circulation-img2.jpg",
      "aspect-ratio": 1200 / 368,
      "max-width": "1200",
      "contain": "",
      "data-aos": "fade-up",
      "data-aos-delay": "100"
    }
  }), _c('v-img', {
    staticClass: "d-md-none mx-auto",
    attrs: {
      "src": "/images/sub/circulation/circulation-img2-mo.jpg",
      "max-width": "672",
      "contain": "",
      "data-aos": "fade-up",
      "data-aos-delay": "100"
    }
  })], 1), _c('page-section', {
    staticClass: "page-section--last",
    attrs: {
      "title": "경진대회 주요 자료",
      "text": (_vm$festa2 = _vm.festa) === null || _vm$festa2 === void 0 ? void 0 : (_vm$festa2$section = _vm$festa2.section4) === null || _vm$festa2$section === void 0 ? void 0 : _vm$festa2$section.txt
    }
  }, [_c('div', {
    staticClass: "tab-wrap",
    attrs: {
      "data-aos": "fade-right",
      "data-aos-delay": "100"
    }
  }, [_c('u-tabs', _vm._l(_vm.categories, function (category, index) {
    return _c('u-tab', {
      key: index,
      on: {
        "click": function click($event) {
          _vm.filter.category = category, _vm.search(true);
        }
      }
    }, [_vm._v(" " + _vm._s(category) + " ")]);
  }), 1)], 1), _c('v-divider', {
    staticClass: "grey darken-4 mb-20px mb-md-32px",
    staticStyle: {
      "border-width": "2px 0 0"
    }
  }), _c('v-row', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "200"
    }
  }, _vm._l(_vm.datas, function (data) {
    return _c('v-col', {
      key: data._id,
      attrs: {
        "cols": "6",
        "md": "4"
      }
    }, [_c('card-board', {
      attrs: {
        "to": "/circulation/data/".concat(data._id),
        "chip": data === null || data === void 0 ? void 0 : data.awardName,
        "title": data === null || data === void 0 ? void 0 : data.subject,
        "teamName": data === null || data === void 0 ? void 0 : data.name,
        "view": String(data === null || data === void 0 ? void 0 : data.viewCount)
      }
    })], 1);
  }), 1), _c('v-layout', {
    staticClass: "mt--md",
    attrs: {
      "justify-center": ""
    }
  }, [_c('v-btn', {
    staticClass: "v-btn--width-fixed justify-space-between",
    attrs: {
      "to": "/circulation/data",
      "color": "grey",
      "dark": ""
    }
  }, [_vm._v("더 보기 "), _c('v-icon', {
    staticClass: "font-size-18"
  }, [_vm._v("mdi-plus")])], 1)], 1)], 1)] : _vm._e()], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }